// extracted by mini-css-extract-plugin
export default {"FullWidth":"index_FullWidth__1t4qT","Article":"index_Article__1vIRn","image":"index_image__2pCl6"};